import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 8h4l-4 8h4","key":"svg-1"}]]

const IconCircleLetterZ = createReactComponent('outline', 'circle-letter-z', 'CircleLetterZ', __iconNode);

export default IconCircleLetterZ;